import { QuoteChargeListingEntity, QuoteLineItemType } from '../types';

/**
 * Stable key for a listing entity — mirrors the API calculator's `rowKey`
 * (`equipment:{id}` | `charge:{id}`). Used to match form rows to the server's
 * per-row calc results (e.g. for group subtotals).
 */
export const getRowKey = (row: QuoteChargeListingEntity): string | null => {
  if (row.type === QuoteLineItemType.Equipment) {
    return row.equipment?.equipmentId ? `equipment:${row.equipment.equipmentId}` : null;
  }

  return row.charge?.id ? `charge:${row.charge.id}` : null;
};
